import { useCallback, useEffect, useState } from 'react';
import { equipesApi } from './resources';
import { ACCESS_ROLE } from '../lib/access';

/**
 * Les équipes vues par le compte connecté :
 * - le patron et le directeur des travaux lisent toutes les équipes ;
 * - un technicien ou la secrétaire lit celle qu'il dirige, et `limite` dit
 *   s'il ne voit que son équipe ;
 * - les autres n'en lisent aucune.
 *
 * @returns {{equipes: object[], limite: boolean, recharge: () => void, setEquipes: Function}}
 */
export function useEquipes() {
  const [equipes, setEquipes] = useState([]);
  const [limite, setLimite] = useState(false);

  const recharge = useCallback(async () => {
    try {
      if (ACCESS_ROLE === 'patron' || ACCESS_ROLE === 'directeur') {
        const l = await equipesApi.liste();
        setEquipes(Array.isArray(l) ? l : []);
        setLimite(false);
      } else if (ACCESS_ROLE === 'technicien' || ACCESS_ROLE === 'secretaire') {
        const m = await equipesApi.moi();
        setEquipes(Array.isArray(m?.equipes) ? m.equipes : []);
        setLimite(!!m?.limite);
      }
    } catch {
      // Sans réponse, rien ne change : l'écran reste comme avant les équipes.
    }
  }, []);

  useEffect(() => {
    recharge();
  }, [recharge]);

  return { equipes, limite, recharge, setEquipes };
}
